import { Injectable } from "@angular/core";
import { BaseResponse } from "../../../../objects/common/baseResponse";
import { Order } from "../../../../objects/orders/order";
import { OrderService } from "../../../../services/orderService";
import { ActivatedRouteSnapshot } from "@angular/router";
import { DocumentService } from "../../../../services/documentService";
import { CBP3461 } from "../../../../objects/documents/CBP3461";

@Injectable()
export class OrderDataResolver {

    constructor(private documentService: DocumentService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<BaseResponse<Array<CBP3461>>> {
        let orderId = route.params["id"];

        if (String.isNullOrEmpty(orderId))
            orderId = route.params['orderId'];

        if (!orderId)
            return null;

        return this.documentService.getDocuments<CBP3461>(orderId, 'CBP3461', 0, 100);
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/orderData.resolver.ts